import Box from "@mui/material/Box";
import ReactEcharts from "echarts-for-react";
import { forwardRef } from "react";
import NoDataAvailable from "../../components/NoDataAvailable";

const FootDragChart = forwardRef((props, ref) => {
    const { rawData, group } = props;

    if (!rawData || rawData.length === 0) {
        return (
            <NoDataAvailable />
        );
    }

    const timeSeries = rawData.map(item => item.ms / 1000);
    const FootDrag = rawData.map(item => item.footdrag);

    const minTime = Math.min(...timeSeries);
    const normalizedTimeSeries = timeSeries.map(time => time - minTime)
    const interval = Math.floor(normalizedTimeSeries.length / 10);

    const option = {
        group: group,
        title: {
            text: 'Foot Drag',
            left: 'left',
            padding: 10,
        },
        color: ['#9FD3D3'],
        tooltip: {
            trigger: 'axis',
        },
        legend: {},
        xAxis: {
            type: 'category',
            axisLabel: {
                interval: interval,
                formatter: function (value) {
                    return parseFloat(value).toFixed(2);
                }
            },
            data: normalizedTimeSeries || [],
            name: 'Time',
            nameTextStyle: {
                fontSize: 15,
            },
            axisLine: {
                lineStyle: {
                    color: '#000000',
                },
            },
        },
        yAxis: {
            type: 'value',
            name: '',
            nameTextStyle: {
                fontSize: 15,
            },
            axisLine: {
                lineStyle: {
                    color: '#000000',
                },
            },
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: {
                    show: true,
                    title: 'Save As Image',
                    name: 'foot_drag_chart',
                    excludeComponents: ['toolbox'],
                    pixelRatio: 2,
                },
            },
        },
        dataZoom: [
            {
                type: 'slider',
                start: 0,
                end: 100,
                bottom: 10,
                xAxisIndex: [0],
                borderColor: '#68B3C8',
                handleColor: '#68B3C8',
                handleSize: '80%',
                textStyle: {
                    color: '#333'
                }
            },
            {
                type: 'inside',
                start: 0,
                end: 100,
                xAxisIndex: [0],
            },
        ],
        series: [
            {
                name: 'Foot_Drag',
                data: FootDrag || [],
                type: 'line',
                smooth: true,
                lineStyle: {
                    normal: {
                        width: 4,
                        type: 'solid',
                    },
                },
                areaStyle: {
                    color: '#E9EFFD',
                },
                symbolSize: 6,
            },
        ],
    };

    return (
        <Box width="80%" height="400px" borderRadius={3} boxShadow={5} p={1}>
            <ReactEcharts 
                ref={ref} 
                option={option} 
                style={{ height: '100%' }}
                opts={{ renderer: 'canvas' }}
            />
        </Box>
    );
});

export default FootDragChart;